import PropTypes from 'prop-types';
export const rankingTilePropTypes = {
  label: PropTypes.string,
  heading: PropTypes.string,
  score: PropTypes.number,
  picture: PropTypes.object,
  description: PropTypes.string,
  buttons: PropTypes.array,
  accordion: PropTypes.array,
  productId: PropTypes.string,
  classname: PropTypes.string
};